module.exports = __webpack_public_path__ + "img/vertical_4_4_3009.64aa383c.png";